import templateContentApi from "../api/template-content-api";

const add = async (payload) => {
    const resp = await templateContentApi.add(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const edit = async (payload) => {
    const resp = await templateContentApi.edit(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const remove = async (payload) => {
    const resp = await templateContentApi.remove(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const search = async (condition, pagination) => {
	try {
		const result = await templateContentApi.search(condition, pagination);
		return { list: result.list, pagination: result.paginable };
	} catch (err) {
		console.error(err);
		throw err;
	}
};

const getById = async (payload) => {
    const resp = await templateContentApi.getById(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const templateContentService = {
    add,
    edit,
    remove,
    search,
    getById
};

export default templateContentService;